let $vm
import getLinkString from '../utils/sign.js'
import md5 from 'md5'
import Cookies from '../../static/js/js-cookie'
// Cookies.defaults.expires = 1 / 24
// Cookies.defaults.domain = '.91weijia.cn'

// 设置cookie保存的域名
let DOMAIN = '.91weijia.com'
let hostname = window.location.hostname.split('.')
if (hostname[hostname.length - 1] === 'cn') {
  DOMAIN = '.91weijia.cn'
}

const generatorUUID = () => {
  let ret = []
  do {
    ret.push(Math.floor(Math.random() * 10))
  } while (ret.length < 15)
  return ret.join('')
}

const patchUrl = (url) => {
  let device = $vm.$device
  let browser = $vm.$browser
  let params = $vm.$stringify({
    st: device.isWechat ? 'weixin' : browser.name,
    sv: browser.version,
    pt: browser.name,
    sr: '1',
    vs: '1.0.0'
  })
  if (url.indexOf('?') > -1) {
    return `${url}&${params}`
  }
  return `${url}?${params}`
}

const resolveJSON = (json, done = () => {}, fail = () => {}) => {
  let {code, msg} = json
  let data = json.data || {}
  let page = data.page
  let info = data.info

  if (code === '0000') {
    done(info, page, json)
  } else if (code === '1001') {
    // 签名失败， 清除token，跳转到登录页面
    store.removeUserToken()
    return $vm.$router.replace('/auth/login')
  } else if (code === '1002') {
    // 未实名认证，跳转到实名认证页面
    return $vm.$router.replace('/auth/authentication')
  } else {
    fail(msg, json)
  }
}

const store = {
  _keys: [],
  put (key, val) {
    /* eslint-disable no-undef */
    localStorage.setItem(key, val)
    // 设置cookie过期时间，默认是一小时，如果是微信内部公众号登录，则是永永久（一年）登录
    let expires = 1 / 24
    let domain = ''
    if ($vm.$device.isWechat && $vm.$from().isInner) {
      expires = 365
    }
    if (key === '5i5aj-user-token') {
      domain = DOMAIN
    }
    Cookies.set(key, val, {expires, domain})
    return this
  },
  get (key) {
    return localStorage.getItem(key)
  },
  remove (k) {
    localStorage.removeItem(k)
    Cookies.remove(k)
    return this
  },
  clear () {
    localStorage.clear()
    let allCookies = Cookies.get()
    // 只删除手动存储的cookie
    for (let key of allCookies) {
      if (/^5i5aj/.test(key) || key === 'version') {
        Cookies.remove(key)
      }
    }
    return this
  },
  cache (key, val = key) {
    if (key === val) {
      key = '5i5aj-cache-data'
    }
    let flag = false
    let o = {}
    for (let i = 0, len = this._keys.length; i < len; i++) {
      if (o[this._keys[i]]) {
        flag = true
        break
      }
      o[this._keys[i]] = true
    }
    flag && this._keys.push(key)
    return this.put(key, val)
  },
  getCache (key = '5i5aj-cache-data') {
    return this.get(key)
  },
  clearCache () {
    this._keys.forEach((k) => {
      this.remove(k)
    })
    return this
  },
  getUserToken () {
    let token = this.get('5i5aj-user-token')
    if (token) {
      token = JSON.parse(token)
    }
    return token
  },
  setUserToken (token) {
    return this.put('5i5aj-user-token', JSON.stringify(token))
  },
  removeUserToken () {
    return this.remove('5i5aj-user-token')
  },
  getCity () {
    let city = this.get('5i5aj-current-city') || null
    city = JSON.parse(city)
    if (!city || /[A-Za-z]/.test(city.code)) {
      city = {
        code: '110100',
        name: '北京市',
        remarks: '4007705127'
      }
      this.setCity(city)
    }
    return city
  },
  setCity (city) {
    return this.put('5i5aj-current-city', JSON.stringify(city))
  },
  updateCapt () {
    let captId = this.updateCaptId()
    return `/captchaImage.jhtml?captId=${captId}&sr=1`
  },
  updateCaptId () {
    let captId = generatorUUID()
    this.put('5i5aj-captId', captId)
    return captId
  },
  getCaptId () {
    let captId = this.get('5i5aj-captId')
    if (!captId) {
      captId = this.updateCaptId()
    }
    return captId
  }
}

const CopyLocalStorage = () => {
  // 首先判断cookie有没有存储数据，如果没有，则需要拷贝，如果有，则不做任何事情
  let token = Cookies.getJSON('5i5aj-user-token') || null
  if (!token) {
    let token = store.getUserToken() // token

    // let timeout = store.getCache('5i5aj-token-timeout') // 过期时间
    if (token && token.uid) {
      let domain = DOMAIN
      let expires = 1 / 24
      Cookies.set('5i5aj-user-token', token, {expires, domain})
    }
  }
}

CopyLocalStorage()

const ajax = (options) => {
  options = $vm.$assign({
    url: '',
    params: {},
    settings: {},
    done () {},
    fail (m) {
      $vm.$dialog(m)
    },
    always () {}
  }, options)
  options.params.dateTime = Date.now()
  if (/[/]center[/]/.test(options.url)) {
    let mac = JSON.parse(store.get('5i5aj-user-token'))['mac']
    let sign = getLinkString(options.params, true) + mac
    options.params.sign = md5(sign)
  }
  return $vm.$http.post(patchUrl(options.url), options.params, options.settings)
    .then((response) => response.json())
    .then((json) => {
      resolveJSON(json, options.done, options.fail)
    })
    .catch((response) => {
      $vm.$dialog(`[${response.status}] ${response.statusText}`)
    })
    .finally((response) => {
      let now = Date.now()
      if (!$vm.$device.isWechat || !$vm.$from().isInner) {
        // 不是微信或者不是内部公众号
        let token = store.getUserToken()
        let timeout = store.getCache('5i5aj-token-timeout')
        if (token && timeout) {
          let time = now - (timeout - 0)
          if (time / 1000 / 60 / 60 >= 1) {
            store.removeUserToken()
          }
        }
      }
      store.cache('5i5aj-token-timeout', now + '')
      options.always(response)
    })
}

export default function (Vue) {
  Vue.cache = store
  Vue.ajax = ajax

  Vue.mixin({
    created () {
      if (!$vm) {
        $vm = this
      }
      this.$cache = store
      this.$ajax = ajax
    }
  })
}



// WEBPACK FOOTER //
// ./src/plugins/ajax.js